<template>
  <div class="template-wrap prod-tile-tooltip-template">
    <div class="subject">
      <span>{{ data.subject }}</span>
      <span>
        {{ data.FriendlyStatus }}
      </span>
    </div>
    <div class="description">
      <span>{{ data.ProductCode }}</span> -
      <span>{{ data.ProductDescription1 }} </span>
    </div>
    <div class="data">
      <div class="planned">
        <span>Planned </span>&nbsp;
        <span>
          {{ getFormattedQty(data.RequiredQty) }}
          {{ data.StockUM }}
        </span>
      </div>
      <div class="actual">
        <span>Actual</span>&nbsp;
        <span>
          {{ getFormattedQty(data.RequiredQty) }}
          {{ data.StockUM }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { formatNumber } from "devextreme/localization";
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getFormattedQty(value) {
      return formatNumber(value, "##,###,###,###,##0.00");
    },
  },
};
</script>

<style lang="scss">
.e-tooltip-wrap {
  width: auto;
  .prod-tile-tooltip-template {
    width: auto;
    display: flex;
    flex-direction: column;
    .subject {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
    }

    .subject span:last-child {
      font-size: 10px;
    }

    .description {
      display: inline;
      font-size: 12px;
    }

    .data {
      font-size: 10px;
      display: inline-flex;

      .actual {
        padding-left: 25px;
      }
    }
  }
}
</style>